import { FaqEntity } from '../../../graphql/generated/graphql';
import { ToRequiredType } from '../../../types/typeDef';
import { FaqDef } from '../../../types/Faq/faq.def';

export const getFaqDefFromQuery: (faq: Partial<FaqEntity>) => FaqDef = faq => ({
  ...(faq.attributes as ToRequiredType<typeof faq.attributes>),
  id: faq.id,
  media: faq.attributes?.medias?.data?.map(m => ({ url: m.attributes?.url }))
});
